import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(chtDate, list) {         

      let actData = chtDate.filter(f=> f.CDATE <= this.timeline.cutoff.date)

      let charts = this.canvasChart
      .append('g')
      .attr('transform', `translate(${list.x}, ${list.y + this.chart.y})`)
      .style('font-family', 'roboto')

      // Bar Chart 
      this.chart.styles.filter(f=> f.type == 'BAR').forEach((st,i)=> {
        let data = (st.act == 'Y') ? actData : chtDate
        this.draw_BarChart(charts, data, st, i) // -----> below
      })

      // Line Chart 
      this.chart.styles.filter(f=> f.type == 'LINE').forEach((st,i)=> {
        let data = (st.act == 'Y') ? actData : chtDate
        this.draw_LineChart(charts, data, st)
        if(this.chart.lastValue > 0) this.draw_lastValue(charts, data, st) // -----> below
      })
    },


    draw_BarChart(selection, _data, _st, _sn) {
      
      _data.forEach((d,i)=> {
        
        let value = (d[_st.code] < 0) ? 0 : d[_st.code]

        selection
        .append('rect')
        .attr('x', d.bxs[_sn])
        .attr('y', this.chart.height-this.primary.axis(value))
        .attr('width', _st.size).attr('height', this.primary.axis(value))
        .attr('fill', _st.color).attr('opacity', _st.opacity)

        if(_st.vSize > 0 && value > 0) {
          selection
          .append('text')
          .attr('x', d.bxs[_sn] + (_st.size/2))
          .attr('y', this.chart.height-this.primary.axis(value) -2)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(value)
        }
      })
    },


    draw_LineChart(selection, _data, _st) {
      let lineFunc = d3.line()
      .x(d => d.mx)
      .y(d => this.secondary.axis(d[_st.code]))

      selection
      .append('path')
      .attr('d', lineFunc(_data))
      .attr('stroke', _st.color).attr('stroke-width', _st.size)
      .attr('fill', 'none').attr('opacity', _st.opacity)
      .style("stroke-dasharray", (_st.ltype, _st.ltype))

      _data.forEach((d,i)=> {
        // Node
        if(_st.node > 0) {
          selection
          .append('circle')
          .attr('cx', d.mx)
          .attr('cy', this.secondary.axis(d[_st.code]))
          .attr('r', _st.node)
          .attr('fill', _st.color).attr('opacity', _st.opacity)
        }
        // Value
        if(_st.vSize > 0 && d[_st.code] > 0) {
          selection
          .append('text')
          .attr('x', d.mx)
          .attr('y', this.secondary.axis(d[_st.code]) -4)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(d[_st.code])
        }
      })
    },


    draw_lastValue(selection, _data, _st) {
      let lastOne = _data.find(f=> f.CDATE == this.timeline.cutoff.date)

      if(_st.type == 'LINE') {
        if(!lastOne) return
        selection
        .append('text')
        .attr('x', lastOne.mx + 5)
        .attr('y', this.secondary.axis(lastOne[_st.code]) + this.chart.lastValue*0.36)
        .attr('font-size', this.chart.lastValue).attr('fill', _st.vColor)
        .text(lastOne[_st.code])
      }
    },

  }
}